export enum ETipoParticipante
{
    Tomador = 1,
    Remetente = 2,
    Destinatario = 3,
    Expedidor = 4,
    Recebedor = 5,
}
